import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import './CookieBanner.css';

const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
            // Small delay for smooth appearance
            setTimeout(() => setShowBanner(true), 300);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('cookieConsent', 'all');
        setShowBanner(false);
    };

    const handleAcceptNecessary = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        setShowBanner(false);
    };

    if (!showBanner) {
        return null;
    }

    return (
        <Alert 
            variant="info"
            className="cookie-banner"
        >
            <div className="cookie-banner-content">
                <div className="cookie-banner-text">
                    <strong>We use cookies</strong>
                    <span className="cookie-banner-message">
                        {' '}This website uses cookies to improve your browsing experience, analyze site traffic, and personalize content. 
                        Essential cookies are required for the site to function properly. By clicking "Accept All", you consent to our use of all cookies. 
                        You may choose "Accept Necessary" to only allow essential cookies.
                    </span>
                </div>
                <div className="cookie-banner-buttons">
                    <Button 
                        variant="outline-primary"
                        size="sm"
                        onClick={handleAcceptNecessary}
                        className="cookie-button-necessary"
                    >
                        Accept Necessary
                    </Button>
                    <Button 
                        variant="primary"
                        size="sm"
                        onClick={handleAcceptAll}
                        className="cookie-button-accept"
                    >
                        Accept All
                    </Button>
                </div>
            </div>
        </Alert>
    );
};

export default CookieBanner;

